import { IonCheckbox } from '@ionic/react'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { UserPreferenceOptions } from '../types/types'

interface Props {
	options: UserPreferenceOptions | undefined
	setOptions: React.Dispatch<React.SetStateAction<UserPreferenceOptions | undefined>>
}

const checkboxClass =
	'radio dark:[--border-color:#3cb49f] dark:[--border-color-checked:#3cb49f] dark:[--checkbox-background-checked:#3cb49f] dark:[--checkbox-background:#144448] [--border-color:#52ae32] [--border-color-checked:#52ae32] [--checkbox-background-checked:#52ae32] [--checkbox-background:#cae3cc] shrink-0'

const OptionCard: React.FC<{
	checked: boolean
	onChange: () => void
	label: string
}> = ({ checked, onChange, label }) => (
	<div
		role='button'
		tabIndex={0}
		onClick={onChange}
		onKeyDown={e => e.key === 'Enter' && onChange()}
		style={{
			display: 'flex',
			alignItems: 'center',
			gap: '12px',
			padding: '12px 16px',
			borderRadius: '12px',
			border: `1.5px solid ${checked ? 'rgba(60,180,159,0.6)' : 'rgba(255,255,255,0.1)'}`,
			background: checked ? 'rgba(60,180,159,0.1)' : 'rgba(255,255,255,0.04)',
			marginBottom: '10px',
			cursor: 'pointer',
		}}
	>
		<IonCheckbox checked={checked} onIonChange={onChange} className={checkboxClass} />
		<span
			style={{
				fontWeight: 600,
				fontSize: '15px',
				color: checked ? '#3cb49f' : 'rgba(255,255,255,0.75)',
			}}
		>
			{label}
		</span>
	</div>
)

const UserPreferenceQuestions: React.FC<Props> = ({ options, setOptions }) => {
	const { t } = useTranslation('pages_onboarding')

	return (
		<div className='flex flex-col gap-6'>
			<div className='flex flex-col'>
				<p className='text-sm font-medium text-gray-400 dark:text-gray-400 mb-3'>
					{t('userPreferenceQuestions.vertailuarvot')}
				</p>
				<OptionCard
					checked={options?.preference === 'nature'}
					onChange={() => setOptions(s => ({ ...s, preference: 'nature' }))}
					label={t('userPreferenceQuestions.eko')}
				/>
				<OptionCard
					checked={options?.preference === 'money'}
					onChange={() => setOptions(s => ({ ...s, preference: 'money' }))}
					label={t('userPreferenceQuestions.raha')}
				/>
			</div>

			<div className='flex flex-col'>
				<p className='text-sm font-medium text-gray-400 dark:text-gray-400 mb-3'>
					{t('userPreferenceQuestions.teknologiaKiinnostus')}
				</p>
				<OptionCard
					checked={options?.interestedInTech === true}
					onChange={() => setOptions(s => ({ ...s, interestedInTech: true }))}
					label={t('kylla', { ns: 'common' })}
				/>
				<OptionCard
					checked={options?.interestedInTech === false}
					onChange={() => setOptions(s => ({ ...s, interestedInTech: false }))}
					label={t('en', { ns: 'common' })}
				/>
			</div>
		</div>
	)
}

export default UserPreferenceQuestions
